import { Text } from "@sitecore-jss/sitecore-jss-nextjs";
import { NextImage } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { useMemo } from "react";
import * as Flex from "@repo/ui/flex";
import * as List from "@repo/ui/list";
import * as Viewport from "@/components/viewport";
import { TYPOGRAPHY_HEADING4 } from "@/theme/topshop-2/typography/typography-constants";
import { appendRef } from "../../utils";
import Carousel from "../carousel/carousel";
import { CategoryShowcaseCarouselSlide } from "../types";
import styles from "./category-showcase-carousel.module.css";

interface CategoryShowcaseCarousel {
  slides: Array<CategoryShowcaseCarouselSlide>;
}

const CategoryShowcaseCarousel = ({ slides }: CategoryShowcaseCarousel) => {
  const carouselSlides = useMemo(() => {
    return slides.map(({ id, text, ctaLink, ctaRef, image }, index) => {
      const hrefWithCtaRef = appendRef(ctaLink.href, ctaRef.value);

      return (
        <a key={id} href={hrefWithCtaRef} className={styles.mediaContainerLink}>
          <List.Item
            data-testid="carousel-slide"
            id={index.toString()}
            className={styles.carouselSlide}
          >
            <NextImage className={styles.video} field={image} unoptimized />
            <Flex.Container justify="center" className={styles.textOverlay}>
              <Text
                tag="h4"
                className={clsx(styles.carouselSlideText, TYPOGRAPHY_HEADING4)}
                field={text}
              />
            </Flex.Container>
          </List.Item>
        </a>
      );
    });
  }, [slides]);

  return (
    <div className={styles.container}>
      <Viewport.Small>
        <Carousel slides={carouselSlides} slideGap={"md"} />
      </Viewport.Small>
      <Viewport.Large>
        <Carousel slides={carouselSlides} slideGap={"sm"} />
      </Viewport.Large>
    </div>
  );
};

export default CategoryShowcaseCarousel;
